var CardStatus;
(function (CardStatus) {
    CardStatus["unactivated"] = "unactivated";
    CardStatus["active"] = "active";
    CardStatus["suspended"] = "suspended";
    CardStatus["canceled"] = "canceled";
    CardStatus["pending"] = "pending";
})(CardStatus || (CardStatus = {}));
var Network;
(function (Network) {
    Network["unknown"] = "unknown";
    Network["amex"] = "amex";
    Network["mastercard"] = "mastercard";
    Network["visa"] = "visa";
    Network["demo"] = "demo";
})(Network || (Network = {}));
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus["pending"] = "pending";
    ConnectionStatus["active"] = "active";
    ConnectionStatus["disconnected"] = "disconnected";
    ConnectionStatus["deactivated"] = "deactivated";
})(ConnectionStatus || (ConnectionStatus = {}));
var CardsGatewayIssuer;
(function (CardsGatewayIssuer) {
    CardsGatewayIssuer["Amex"] = "amex";
    CardsGatewayIssuer["Emburse"] = "emburse";
    CardsGatewayIssuer["Gringotts"] = "gringotts";
    CardsGatewayIssuer["CapitalOne"] = "capital-one";
})(CardsGatewayIssuer || (CardsGatewayIssuer = {}));
export { CardStatus, ConnectionStatus, CardsGatewayIssuer };
